module.exports = __webpack_public_path__ + "img/chanjian.95908b20.png";